import { paths } from '@Components/configs';
import { ADMIN_AUTH_API_ERROR } from '../actions/actionTypes';
import { adminLogOut } from '../actions/admin/authActions';
import { initiateRedirectRequest } from '../actions/redirectActions';

/*
 * Middleware to handle admin authentication errors globally.
 * If an action with type ADMIN_AUTH_API_ERROR and a 401/403 status is dispatched,
 * it will log out the admin user and redirect to the admin login page.
 */
const handleAdminAuth = (store) => (next) => (action) => {
  // Check for a standardized API error action
  if (
    action.type === ADMIN_AUTH_API_ERROR
    && action.error
    && (action.error.status === 401 || action.error.status === 403)
  ) {
    store.dispatch(adminLogOut());
    store.dispatch(initiateRedirectRequest(null, paths.adminLogin));
    return null; // Prevent further propagation
  }

  return next(action);
};

export default handleAdminAuth;
